import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Post, Gym } from "./types";
import { useToast } from "@/components/ui/use-toast";

export const useNewsActions = () => {
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [selectedGym, setSelectedGym] = useState<Gym | null>(null);
  const [hiddenPosts, setHiddenPosts] = useState<Set<string>>(new Set());
  const { toast } = useToast();

  const fetchGymDetails = async (gymId: string | undefined) => {
    if (!gymId) return;
    
    const { data: gym } = await supabase
      .from('gyms')
      .select('name, address')
      .eq('id', gymId)
      .single();

    if (gym) {
      setSelectedGym(gym);
    }
  };

  const handleShare = async (post: Post) => {
    try {
      const postUrl = `${window.location.origin}/noticias/${post.id}`;
      await navigator.clipboard.writeText(postUrl);
      
      toast({
        title: "¡URL copiada!",
        description: "La URL de la noticia ha sido copiada al portapapeles"
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error al copiar",
        description: "No se pudo copiar la URL al portapapeles"
      });
    }
  };

  const togglePostVisibility = (postId: string) => {
    setHiddenPosts(prev => {
      const newHiddenPosts = new Set(prev);
      if (newHiddenPosts.has(postId)) {
        newHiddenPosts.delete(postId);
        toast({
          title: "Noticia visible",
          description: "La noticia ha sido restaurada"
        });
      } else {
        newHiddenPosts.add(postId);
        toast({
          title: "Noticia oculta",
          description: "La noticia ha sido ocultada"
        });
      }
      return newHiddenPosts;
    });
  };

  const handlePostSelect = (post: Post) => {
    setSelectedPost(post);
    fetchGymDetails(post.gym_id);
  };

  const handleClose = () => {
    setSelectedPost(null);
    setSelectedGym(null);
  };

  return {
    selectedPost,
    selectedGym,
    hiddenPosts,
    handlePostSelect,
    handleShare,
    togglePostVisibility,
    handleClose
  };
};